import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider, useAuth } from './context/AuthContext';
import InfluencerMarketing from './pages/InfluencerMarketing';
import SoftwareLock from './pages/SoftwareLock';

const QQ_PORTAL = process.env.REACT_APP_QQ_PORTAL_URL || 'http://localhost:7001/my-tools';

/**
 * QQ SSO Protected Route
 * - If loading: show spinner
 * - If locked (expired/suspended): show SoftwareLock overlay
 * - If not authenticated: redirect to QQ client portal
 * - If valid: render children
 */
function QQProtectedRoute({ children }) {
  const { user, qqLocked, qqLockStatus, qqClient, loading, authError } = useAuth();

  if (authError) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#080a12', color: '#ff4b4b', fontFamily: 'Inter, sans-serif', flexDirection: 'column', gap: 16, padding: 20 }}>
        <div style={{ fontSize: 40 }}>⚠️</div>
        <h2 style={{ margin: 0, color: '#fff' }}>SSO Authentication Failed</h2>
        <p style={{ margin: 0, fontSize: 14, color: '#f87171', maxWidth: 600, textAlign: 'center', lineHeight: 1.5 }}>{authError}</p>
        <button onClick={() => window.location.href = QQ_PORTAL} style={{ marginTop: 10, padding: '10px 20px', background: '#7c3aed', color: '#fff', border: 'none', borderRadius: 10, cursor: 'pointer', fontWeight: 'bold' }}>Back to Portal</button>
      </div>
    );
  }

  if (loading) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#080a12', color: '#8892a4', fontFamily: 'Inter, sans-serif', flexDirection: 'column', gap: 16 }}>
        <div style={{ width: 40, height: 40, border: '3px solid rgba(255,255,255,0.08)', borderTopColor: '#8b5cf6', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} />
        <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
        <p style={{ margin: 0, fontSize: 14 }}>Verifying QuirkyQode subscription…</p>
      </div>
    );
  }

  if (qqLocked) {
    return <SoftwareLock status={qqLockStatus} companyName={qqClient?.company_name} />;
  }

  if (!user) {
    // No valid QQ token — redirect to QQ client portal
    window.location.href = QQ_PORTAL;
    return null;
  }

  return children;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* Main protected tool */}
          <Route
            path="/"
            element={
              <QQProtectedRoute>
                <InfluencerMarketing />
              </QQProtectedRoute>
            }
          />
          {/* Catch-all */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>

        <Toaster position="top-right" theme="dark" closeButton />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;

